import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { Subscription } from 'rxjs';
import { AllService } from '../../../services/all.service';
import { IMessengerConnector } from '../../../types/all.type';
import {InterfaceService} from '../../../services/interface.service';
import {isMobile} from '../../../functions';

@Component({
  selector: 'app-chat-media-right',
  templateUrl: './chat-media-right.component.html',
  styleUrls: ['./chat-media-right.component.scss']
})
export class ChatMediaRightComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  arGifs: any = [];
  selectedEmoji: any;
  @Input() Service: IMessengerConnector;
  i18n: any = {
    search: 'Поиск',
    emojilist: 'Список смайликов',
    notfound: 'Смайлы не найдены',
    clear: 'Очистить',
    categories: {
      search: 'Результаты поиска',
      recent: 'Часто используемые',
      people: 'Смайлики и люди',
      nature: 'Животные и природа',
      foods: 'Еда и напитки',
      activity: 'Деятельность',
      places: 'Путешествия и места',
      objects: 'Объекты',
      symbols: 'Символы',
      flags: 'Флаги',
      custom: 'Другое'
    },
    skintones: {
      1: 'Тон кожи по умолчанию',
      2: 'Светлый оттенок кожи',
      3: 'Средне-светлый оттенок кожи',
      4: 'Средний тон кожи',
      5: 'Средне-темный оттенок кожи',
      6: 'Тон темной кожи'
    }
  };
  constructor(
    public interfaceService: InterfaceService,
    public allService: AllService) {}

  ngOnInit(): void {
/*    this.subscriptions.push(
      this.Service.getGifs().subscribe(
        (result: any) => {
          this.arGifs = result.result;
        },
        (error) => {
          ////this.cd.detectChanges();
          this.interfaceService.errorHandling(error);
        }
      )
    );*/
  }
  insert(str, index, value) {
    return str.substr(0, index) + value + str.substr(index);
  }
  addEmoji(event) {
    const { message } = this.Service;
    let { textAreaPosition } = this.allService;
    if (this.interfaceService.messageTextareaType === 'editor') {
      const target = document.createTextNode(event.emoji.native);
      this.interfaceService.editor.commands.focus();
      document
        .getSelection()
        .getRangeAt(0)
        .insertNode(target);

      /*const position = this.in.editor.textArea.nativeElement.innerHTML.indexOf(
        '\u0001'
      );
      const beginning = this.editor.textArea.nativeElement.innerHTML.substring(
        0,
        position || 0
      );
      const end = this.editor.textArea.nativeElement.innerHTML.substring(
        position || 0
      );
      // Removes dummy character and adds content.
      this.htmlContent = this.editor.textArea.nativeElement.innerHTML =
        beginning +
        yourContent +
        end.slice(1);*/
    }else{
      if (textAreaPosition) {
        this.Service.message = this.insert(message, textAreaPosition, event.emoji.native);
      } else {
        this.Service.message = `${message}${event.emoji.native}`;
        textAreaPosition = this.Service.message?.length;
      }
    }

    if (!isMobile() && textAreaPosition) {
      this.interfaceService.positionTextArea$.next(textAreaPosition + 1);
      setTimeout(() => {
        this.interfaceService.focusTextArea$.next(true);
      }, 100);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
